export default __webpack_public_path__ + "static/media/envelope-1.dbc54b5b.svg";